import React, { useState } from "react";
import { motion } from "framer-motion";

import awardHero from "../assets/Awards-cover-photo.png";
import award1 from "../assets/news-hackathon.jpg";

const Awards = () => {

  // ==========================================
  // ADD NEW AWARDS HERE IN THE FUTURE
  // ==========================================
  const awards = [
    {
      img: award1,
      title: "2nd Runner Up — Best Presentation Award",
      year: "Hackathon 2025",

      description: `
        Ajaya Conservation Trust (ACoT) was awarded 2nd Runner-Up – Best Presentation Award at the 110 Hours Hackathon on Biodiversity Conservation & Climate Change, organised by the Zoological Survey of India (ZSI), Estuarine Biology Regional Centre, Gopalpur-on-Sea, Odisha, held on 29 May 2025.
        Fishing Cat Habitat Suitability in Estuarine Odisha:
        Our presentation explored the potential distribution and habitat suitability of the Fishing Cat (Prionailurus viverrinus) across Odisha's estuarine landscapes. The study integrated species occurrence records, GIS-based environmental variables and ensemble species-distribution modelling to identify potential habitat and conservation priorities.
        The analysis highlighted the importance of proximity to water, topographic characteristics and habitat fragmentation in determining areas of higher suitability. Key priority landscapes identified through the study included the Mahanadi delta, Chilika lagoon fringe and Rushikulya estuary.
        The research further proposed practical conservation approaches including protection of high-suitability wetland habitats, maintenance of habitat corridors, wildlife-sensitive aquaculture practices and community-based monitoring.
        29 May 2025 | Gopalpur-on-Sea, Odisha 

      `,
    },

    // ==========================================
    // EXAMPLE FOR FUTURE AWARDS
    // ==========================================

    /*
    {
      img: award2,
      title: "Future Award Name",
      year: "2026",

      description: `
        Add the complete description of the award here.
        You can write as much content as required.
      `,
    },
    */
  ];

  return (
    <div className="bg-black text-white min-h-screen">

      {/* ================= HERO ================= */}

      <section
        className="relative min-h-[55vh] flex items-center justify-center overflow-hidden bg-cover bg-[center_20%]"
        style={{
          backgroundImage: `url(${awardHero})`,
        }}
      >

        {/* Background Overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* Decorative circles */}
        <div className="absolute top-20 left-10 w-40 h-40 bg-lime-400/10 rounded-full blur-3xl"></div>

        <div className="absolute bottom-10 right-10 w-60 h-60 bg-lime-400/10 rounded-full blur-3xl"></div>

        <div className="relative z-10 text-center max-w-4xl mx-auto px-6">

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-lime-400 uppercase tracking-[0.3em] text-sm font-semibold mb-5"
          >
            Recognition & Achievement
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-7xl font-bold mb-6"
          >
            OUR <span className="text-lime-400">AWARDS</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 1,
              delay: 0.2,
            }}
            className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed"
          >
            Celebrating milestones that reflect our commitment to
            biodiversity conservation, scientific research and
            sustainable development.
          </motion.p>

        </div>
      </section>


      {/* ================= AWARDS SECTION ================= */}

      <section className="py-20 bg-gray-950">

        <div className="w-11/12 md:w-4/5 mx-auto">

          {/* Section Heading */}

          <div className="text-center mb-14">

            <p className="text-lime-400 uppercase tracking-[0.25em] text-sm font-semibold mb-3">
              Our Achievements
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-lime-400">
              AWARDS & RECOGNITION
            </h2>

            <div className="w-20 h-1 bg-lime-400 mx-auto mt-5"></div>

            {/* <p className="text-gray-400 mt-5 max-w-2xl mx-auto">
              Every recognition strengthens our commitment to conservation,
              research and creating meaningful environmental impact.
            </p> */}

          </div>


          {/* ================= AWARD CARDS ================= */}

          <div className="space-y-12">

            {awards.map((award, index) => (
              <AwardCard
                key={index}
                award={award}
                index={index}
              />
            ))}

          </div>

        </div>

      </section>


      {/* ================= CTA ================= */}

      <section className="relative py-20 bg-lime-400 text-black overflow-hidden">

        <div className="absolute -top-20 -right-20 w-72 h-72 bg-white/10 rounded-full"></div>

        <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-black/5 rounded-full"></div>

        <div className="relative z-10 w-11/12 md:w-4/5 mx-auto text-center">

          <motion.h2
            initial={{
              opacity: 0,
              y: 30,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{
              once: true,
            }}
            className="text-3xl md:text-4xl font-bold mb-5"
          >
            Every Achievement Inspires Greater Impact
          </motion.h2>

          <p className="max-w-2xl mx-auto text-black/70 text-lg">
            We continue to work towards a future where biodiversity,
            communities and ecosystems thrive together.
          </p>

        </div>

      </section>

    </div>
  );
};


// =====================================================
// REUSABLE AWARD CARD
// =====================================================

const AwardCard = ({ award, index }) => {

  const [expanded, setExpanded] = useState(false);

  return (

    <motion.div
      initial={{
        opacity: 0,
        y: 40,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.7,
        delay: index * 0.1,
      }}
      className="group bg-gray-900 rounded-2xl overflow-hidden shadow-xl border border-gray-800 hover:border-lime-400/50 transition-all duration-300"
    >

      <div className="grid md:grid-cols-2">

        {/* ================= IMAGE ================= */}

        <div className="relative overflow-hidden">

          <img
            src={award.img}
            alt={award.title}
            className="w-full h-72 md:h-full min-h-[350px] object-cover object-top group-hover:scale-105 transition-transform duration-700"
          />

          {/* Image Overlay */}

          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        </div>


        {/* ================= CONTENT ================= */}

        <div className="p-8 md:p-10 flex flex-col justify-center">

          {/* Year */}

          <p className="text-lime-400 uppercase tracking-[0.25em] text-sm font-semibold mb-3">
            {award.year}
          </p>


          {/* Title */}

          <h3 className="text-2xl md:text-3xl font-bold text-white mb-5 leading-tight">
            {award.title}
          </h3>


          {/* Description */}

          <div className="text-gray-300 leading-relaxed text-sm md:text-base whitespace-pre-line">

            {expanded
              ? award.description
              : `${award.description.trim().substring(0, 350)}...`
            }

          </div>


          {/* Read More / Less */}

          <button
            onClick={() => setExpanded(!expanded)}
            className="mt-6 self-start text-lime-400 font-semibold hover:text-lime-300 transition-colors duration-300"
          >
            {expanded ? "Read Less ↑" : "Read More →"}
          </button>

        </div>

      </div>

    </motion.div>

  );
};

export default Awards;